import { Checkbox, CollapseProps, Descriptions, Typography } from 'antd';
import { useContext, useEffect, useState } from 'react';
import CollapseCustom from 'src/components/v2/Collapse';
import { TicketDetailContext } from 'src/contexts/ticketDetail.context';
import { ITicketForm } from 'src/types/helpdesk/ticket.type';
import { isJsonType } from 'src/utils/utils';
import './TicketForm.scss';
import dayjs from 'dayjs';
const { Text } = Typography;

const TicketForm = (): JSX.Element => {
  const { ticket } = useContext(TicketDetailContext);
  const [ticketForms, setTicketForms] = useState<ITicketForm[][]>([]);

  useEffect(() => {
    if (ticket?.data.ticketForms) {
      const groupedByKey = (ticket?.data.ticketForms as ITicketForm[])?.reduce?.<Record<string, ITicketForm[]>>(
        (acc, obj) => {
          // Kiểm tra xem obj đã tồn tại chưa, nếu không thì tạo mới
          if (!acc[obj?.rowId]) {
            acc[obj.rowId] = [];
          }
          // Thêm obj vào nhóm tương ứng
          acc[obj.rowId].push(obj);
          return acc;
        },
        {}
      );

      setTicketForms(Object.values(groupedByKey));
    }
  }, [ticket?.data.ticketForms]);

  const renderData = (ticketForm: ITicketForm) => {
    if (isJsonType(ticketForm.value)) {
      const valueParse = JSON.parse(ticketForm.value);
      if (typeof valueParse === 'boolean') {
        return <Checkbox checked={valueParse} />;
      } else {
        const valueFlatItem = {
          id: valueParse.id,
          name: valueParse.name || valueParse.fullName || valueParse.value || valueParse.id,
          code: valueParse.code
        };

        return <Text>{valueFlatItem.name}</Text>;
      }
    } else if (new Date(ticketForm.value).getMonth()) {
      return <Text>{dayjs(new Date(ticketForm.value)).format('DD-MM-YYYY')}</Text>;
    } else {
      return <Text>{ticketForm.value}</Text>;
    }
  };

  const ticketFormItems = (ticketForms: ITicketForm[][]): CollapseProps['items'] => {
    return ticketForms.map((ticketForm, index) => ({
      label: (
        <Descriptions
          layout='horizontal'
          labelStyle={{ width: '135px' }}
          column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
        >
          {ticketForm.map((ticketFormChild) => (
            <Descriptions.Item label={ticketFormChild.label} key={ticketFormChild.id}>
              {renderData(ticketFormChild)}
            </Descriptions.Item>
          ))}
        </Descriptions>
      ),
      showArrow: false,
      className: 'ticket-form-item'
    }));
  };

  return (
    <CollapseCustom
      titleLevel={5}
      bordered={false}
      isSegmented={false}
      items={ticketFormItems(ticketForms)}
      expandIconPosition='end'
      className='ticket-form-list'
      collapsible='disabled'
    />
  );
};
export default TicketForm;
